/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Notifications32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.692v16.616c0 2.675.278 3.645.801 4.622A5.452 5.452 0 003.07 31.2c.978.522 1.948.801 4.623.801h16.616c2.675 0 3.645-.279 4.622-.801A5.452 5.452 0 0031.2 28.93c.522-.977.801-1.947.801-4.622V7.692c0-2.675-.279-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            fill={vars.bdlDarkBlue}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 21.8a1.6 1.6 0 11-3.2 0H18zM16.402 9c.878 0 1.6.72 1.6 1.6 1.901.451 3.198 2 3.198 4.8v2.392c0 .454.32.97.714 1.17l.086.044c.8.394.8 1.198.8 1.198V21H10v-.802a1.43 1.43 0 01.802-1.2l.086-.042c.387-.194.712-.718.712-1.163V15.4c0-2.8 1.038-4.352 3.2-4.8 0-.88.726-1.6 1.602-1.6z"
            fill="#fff"
        />
    </AccessibleSVG>
);

export default Notifications32;
